import { Divider, Paper, useMediaQuery } from "@material-ui/core";

import styles from "./styles";

type props = {
  allChartData?: any;
};

const AuditDButtons = ({ allChartData }: props) => {
  const matches = useMediaQuery("(min-width:820px)");
  const mediumScreen = useMediaQuery("(min-width:700px)");
  const smallScreen = useMediaQuery("(min-width:450px)");
  const classes = styles(mediumScreen)();

  return (
    <div
      style={{
        // background: "#F8F9F9",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-evenly",
        padding: "10px",
        height: matches ? "140px" : "fit-content",
        // marginTop: "40px",
        // backgroundColor: "red",
      }}
    >
      <div className={classes.main_container}>
        <div className={classes.heading}>
          <p className={classes.headingText}>Audits Conducted</p>
        </div>
        <Paper elevation={0} className={classes.paper}>
          <div className={classes.buttons}>
            <div className={classes.count}>
              <p className={classes.countNumber}>
                {allChartData?.auditConducted?.auditPlan}
              </p>
            </div>
            <Divider
              orientation="vertical"
              flexItem
              className={classes.divider}
            />
            <div className={classes.text}>
              <p className={classes.textcontent}>
                AdHoc : {allChartData?.auditConducted?.adHoc}
              </p>
              {/* <p className={classes.textcontent}>
                AuditPlan: {allChartData?.auditConducted?.auditPlan}
              </p> */}
              <p className={classes.textcontent}>
                Audit Report : {allChartData?.auditConducted?.auditReport}
              </p>
              <p className={classes.textcontent}>
                Audit Schedule : {allChartData?.auditConducted?.auditSchedule}
              </p>
            </div>
          </div>
        </Paper>
      </div>

      <div className={classes.main_container}>
        <div className={classes.heading}>
          <p className={classes.headingText}>Findings Raised</p>
        </div>
        <Paper elevation={0} className={classes.paper}>
          <div className={classes.buttons}>
            <div className={classes.count}>
              <p className={classes.countNumber}>
                {allChartData?.findingsConducted?.count?.totalfindings}
              </p>
            </div>
            <Divider
              orientation="vertical"
              flexItem
              className={classes.divider}
            />
            <div className={classes.text}>
              <p className={classes.textcontent}>
                Open : {allChartData?.findingsConducted?.count?.open}
              </p>
              <p className={classes.textcontent}>
                Verfied : {allChartData?.findingsConducted?.count?.verfied}
              </p>
              <p className={classes.textcontent}>
                Clause : {allChartData?.findingsConducted?.count?.clause}
              </p>
            </div>
          </div>
        </Paper>
      </div>

      <div className={classes.main_container}>
        <div className={classes.heading}>
          <p className={classes.headingText}>Auditors</p>
        </div>
        <Paper elevation={0} className={classes.paper} style={{}}>
          <div className={classes.buttons}>
            <div className={classes.count}>
              <p className={classes.countNumber}>
                {allChartData?.auditorData?.auditors}
              </p>
            </div>
            <Divider
              orientation="vertical"
              flexItem
              className={classes.divider}
            />
            <div className={classes.text}>
              <p className={classes.textcontent}>
                Auditor Used : {allChartData?.auditorData?.auditorUsed}
              </p>
            </div>
          </div>
        </Paper>
      </div>

      <div className={classes.main_container}>
        <div className={classes.heading}>
          <p className={classes.headingText}>Audit Coverage</p>
        </div>
        <Paper elevation={0} className={classes.paper}>
          <div className={classes.text}>
            <p className={classes.textcontent}>
              Audited Documents :{" "}
              {allChartData?.auditCoverage?.auditedDocuments}
            </p>
            <p className={classes.textcontent}>
              System : {allChartData?.auditCoverage?.system}
            </p>
          </div>
        </Paper>
      </div>
    </div>
  );
};

export default AuditDButtons;
